// Straighten the hero video card as it scrolls toward the middle of the screen.
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards = document.querySelectorAll('.tbb-hero__card[data-straighten="true"]');
  if (reduce || !cards.length) return;

  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    cards.forEach(function (card) {
      var hero = card.closest('.tbb-hero');
      var tilt = parseFloat(getComputedStyle(hero).getPropertyValue('--tilt')) || 0;
      var rect = card.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      // 1 when the card sits at the bottom of the screen, 0 once it reaches the middle.
      var progress = Math.min(Math.max((center - vh / 2) / (vh / 2), 0), 1);
      card.style.setProperty('--card-tilt', (tilt * progress).toFixed(2) + 'deg');
    });
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', update);
  update();
})();

// Size the YouTube background like object-fit: cover, since iframes can't do it themselves.
(function () {
  var videos = document.querySelectorAll('.tbb-hero__bg-video');
  if (!videos.length) return;

  function fit() {
    videos.forEach(function (frame) {
      var box = frame.parentElement.getBoundingClientRect();
      var width = Math.max(box.width, box.height * 16 / 9);
      frame.style.width = width + 'px';
      frame.style.height = width * 9 / 16 + 'px';
    });
  }
  window.addEventListener('resize', fit);
  document.addEventListener('shopify:section:load', fit);
  fit();
})();
